<template>
  <div id="app">
    <header
      class="mx-auto max-w-7xl px-6 flex flex-col lg:flex-row lg:items-center lg:gap-x-10 lg:px-8"
    >
      <a href="/" class="mt-10">
        <img class="h-16 w-auto" src="Orkla_Snacks_Red_RGB.png" alt="" />
      </a>

      <!-- Mobile menu, show/hide based on menu open state. -->
    </header>

    <router-view />
  </div>
</template>
